module.exports = __webpack_public_path__ + "static/media/logo_caffenio_vertical.0ae8073d.png";